export default __webpack_public_path__ + "static/media/pooja.189802c7.jpg";